import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { AccordionGeneralityForm } from 'civil-status/view-models/accordion-generality-form';
import {
  CODE_NAZIONALITA_ITALIA,
  LABEL_NAZIONALITA_ITALIA,
} from 'shell/components/shared/nationality-list';
import { SubscriptionDatasMunicipality } from 'shell/models/person/subscription-data';
import { IdResidence } from 'civil-status/constants/id-residence';

export const transformerGenerality = (person: SubjectData): AccordionGeneralityForm | undefined => {
  const isIrreperibile = person.datiCancellazione?.motivoCancellazione === '6';
  const residenza = !isIrreperibile && person.residenza ? person.residenza[0] : undefined;
  const datiIscrizioneComune: SubscriptionDatasMunicipality | undefined =
    person.datiIscrizione?.datiIscrizioneComune || undefined;

  if (!Boolean(person?.generalita)) {
    return;
  }

  return {
    idAnpr: person.generalita?.idSchedaSoggettoANPR || '',
    idNationalIdentifier: person.identificativi?.idANPR || '',
    fiscalCode: person.generalita?.codiceFiscale?.codFiscale || '',
    surname: person.generalita?.cognome || '',
    name: person.generalita?.nome || '',
    gender: person.generalita?.sesso || '',
    birthDate: person.generalita?.dataNascita
      ? DateTime.fromISO(person.generalita?.dataNascita)
      : null,
    dateDeath: person.datiDecesso?.dataEvento
      ? DateTime.fromISO(person.datiDecesso?.dataEvento)
      : null,
    // descriptionBirthPlace: person.generalita?.luogoNascita?.localita || '',
    civilStatusItem: { id: person.statoCivile?.statoCivile },
    nationality:
      (person.cittadinanza && person.cittadinanza[0]) || person.idStatoNazionalita
        ? {
            id: person.idStatoNazionalita?.toString() || '',
            value: person.cittadinanza
              ? person.cittadinanza[0]?.descrizioneCittadinanza
              : person.idStatoNazionalita?.toString() === CODE_NAZIONALITA_ITALIA
              ? LABEL_NAZIONALITA_ITALIA
              : '',
            idAnpr: person.idStatoNazionalita?.toString() || '',
          }
        : undefined,
    isForeignBorn: Boolean(person.generalita?.luogoNascita?.localita),
    // generality italian form
    italian: person.generalita?.luogoNascita?.comune
      ? {
          location: person.generalita?.luogoNascita?.comune?.descrizioneLocalita || '',
          province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
          municipality: person.generalita?.luogoNascita?.comune?.codiceIstat
            ? {
                id: person.generalita?.luogoNascita?.comune?.codiceIstat || '',
                description: person.generalita?.luogoNascita?.comune?.nomeComune || '',
                province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
                code: person.idComuneNascita || '',
                idProvince: person.idProvNascita || '',
              }
            : null,
        }
      : undefined,
    // generality foreign form
    foreign: person.generalita?.luogoNascita?.localita
      ? {
          state: person.generalita?.luogoNascita?.localita?.codiceStato
            ? {
                id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                code: person.idStatoNascita || '',
                value: person.generalita?.luogoNascita?.localita?.descrizioneStato || '',
                province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
              }
            : null,
          locationForeignBirth:
            person.generalita?.luogoNascita?.localita?.descrizioneLocalita || '',
          // province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
          // municipality: person.generalita?.luogoNascita?.localita?.codiceStato
          //   ? {
          //       id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
          //       description:
          //         person.generalita?.luogoNascita?.localita?.descrizioneLocalita || '',
          //       province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
          //     }
          //   : null,
        }
      : undefined,
    typeResidence: isIrreperibile
      ? IdResidence.NotKnown
      : Boolean(residenza?.localitaEstera?.indirizzoEstero?.localita)
      ? IdResidence.Foreign
      : Boolean(residenza?.indirizzo?.comune)
      ? IdResidence.Italian
      : IdResidence.NotKnown,
    isUntraceable: isIrreperibile || undefined,
    italianResidence: residenza?.indirizzo?.comune
      ? {
          municipality: {
            id: residenza?.indirizzo?.comune?.codiceIstat || '',
            code: person.idComuneResidenza || '',
            description: residenza?.indirizzo?.comune?.nomeComune || '',
            province: residenza?.indirizzo?.comune?.siglaProvinciaIstat || '',
            idProvince: person.idProvResidenza || '',
            istatCode: residenza?.indirizzo?.comune?.codiceIstat || '',
          },
        }
      : undefined,
    foreignResidence:
      residenza?.localitaEstera?.indirizzoEstero?.localita ||
      (person.generalita?.soggettoAIRE === 'S' && datiIscrizioneComune)
        ? {
            state: residenza?.localitaEstera?.indirizzoEstero?.localita
              ? {
                  id: residenza?.localitaEstera?.indirizzoEstero?.localita?.codiceStato,
                  code:
                    person.idStatoResidenza ||
                    residenza?.localitaEstera?.indirizzoEstero?.localita?.codiceStato,
                  value: residenza?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato,
                  province: residenza?.localitaEstera?.indirizzoEstero?.localita?.provinciaContea,
                }
              : undefined,
            // municipality: residenza?.localitaEstera?.indirizzoEstero?.localita
            //   ? {
            //       id: residenza?.localitaEstera?.indirizzoEstero?.localita?.codiceStato,
            //       description:
            //         residenza?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita,
            //       province: residenza?.localitaEstera?.indirizzoEstero?.localita?.provinciaContea,
            //     }
            //   : undefined,
            municipalityAire:
              person.generalita?.soggettoAIRE === 'S' && datiIscrizioneComune
                ? {
                    id: person?.idComuneAire,
                    code: person?.idComuneAire,
                    istatCode: datiIscrizioneComune?.comune?.codiceIstat || undefined,
                    description: datiIscrizioneComune?.comune?.nomeComune || undefined,
                    idProvince: person?.idProvAire?.toString() || undefined,
                    province: datiIscrizioneComune?.comune?.siglaProvinciaIstat,
                  }
                : undefined,
          }
        : undefined,
    address: isIrreperibile
      ? ''
      : Boolean(residenza?.localitaEstera)
      ? `${residenza?.localitaEstera?.indirizzoEstero?.toponimo?.denominazione || ''} ${
          residenza?.localitaEstera?.indirizzoEstero?.toponimo?.denominazione &&
          residenza?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita
            ? '-'
            : ''
        } ${residenza?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita || ''}
        `
      : `${residenza?.indirizzo?.toponimo?.specie || ''} ${
          residenza?.indirizzo?.toponimo?.denominazioneToponimo || ''
        } ${residenza?.indirizzo?.numeroCivico?.numero || ''}${
          residenza?.indirizzo?.numeroCivico?.numero &&
          (residenza?.indirizzo?.numeroCivico?.lettera ||
            residenza?.indirizzo?.numeroCivico?.esponente1)
            ? '/'
            : ''
        }${residenza?.indirizzo?.numeroCivico?.lettera || ''}${
          residenza?.indirizzo?.numeroCivico?.esponente1 || ''
        }`,
  } as AccordionGeneralityForm;
};
